import React, { createContext, useContext, useState } from "react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("admin_lang") || "EN");

  const handleLangToggle = (selected) => {
    setLang(selected);
    localStorage.setItem("admin_lang", selected);
  };

  return (
    <LanguageContext.Provider value={{ lang, handleLangToggle }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
